;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { z } from 'zod/mini';

// Zelfde validatie als de API (zod 4, z.string().email()); zod-versie gelijk houden met api.synergiejobs.be.
// Bewust overal (ook login/registratie via Firebase): Firebase is soepeler, maar adressen die zod weigert zijn zelden legitiem.
const emailSchema = z.email();

export default function validateEmailAddress(email: string) {
  return z.safeParse(emailSchema, email).success;
}
